<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList">
        <global-select
          slot="supplierId"
          :max-tag-count="2"
          :max-tag-text-length="4"
          show-search
          :value.sync="queryParams.supplierId"
          :setParams="{scpSupplierCategory:'内部'}"
          searchParam="supplierName"
          selectType="selectSearch"
          requestApi="/scp/scpSopMpsSupplierCapacityLoad/supplierPullDown"
          :dropdown-match-select-width="false"
          :selectItem="{ value: 'realValue', label: 'selectedValue' }"
        />
        <global-select
          slot="productBroadCategory"
          :value.sync="queryParams.productBroadCategoryList"
          selectType="selectMultipleSearch"
          requestApi="/system/lookup/data/likeList"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          :setParams="{ lookupType: 'SCP_PRODUCT_BROAD_CATEGORY' }"
          searchParam="lookupValue"
          :dropdown-match-select-width="false"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button type="primary" @click="handleImport">导入</a-button>
        <a-button type="primary" @click="handleExport">导出</a-button>
        <a-button @click="handleDownloadTemplate">下载模板</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :pagination="false"
          :tableProps="tableProps"
          :data-source="tableData"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
        >
        </ls-api-table>
        <!-- 上传文件 -->
        <a-modal
          :title="upload.title"
          :visible="excelVisible"
          @ok="importExcelHandleCancel"
          @cancel="importExcelHandleCancel"
        >
          <a-upload-dragger
            name="file"
            accept=".xlsx, .xls"
            :multiple="true"
            :headers="upload.headers"
            :action="upload.url + '?updateSupport=' + upload.updateSupport"
            @change="importExcelHandleChange"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              请将文件拖拽到此处上传
            </p>
            <p class="ant-upload-hint">
              支持单个或批量上传，也可以点击后选择文件上传
            </p>
          </a-upload-dragger>
        </a-modal>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiScpSopBasicCapacityLoadList } from '@/api/mps/basic-data/work-hour-maintenance'
import moment from 'moment'
import Cookies from 'js-cookie';

export default {
  // eslint-disable-next-line
  name: 'Work-hour-maintenance', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      // 表格配置
      tableProps: {
        requestApi: null
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        supplierId: undefined,
        productBroadCategory: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        {
          label: '供应商名称',
          decorator: ['supplierId'],
          type: 'supplierId'
        },
        {
          label: '工艺大类',
          decorator: ['productBroadCategory'],
          type: 'productBroadCategory'
        }
      ],
      columns: [
        {
          title: '供应商名称',
          dataIndex: 'supplierName',
          align: 'center',
          width: 250,
          ellipsis: true,
          fixed: 'left'
        },
        {
          title: '工艺大类',
          dataIndex: 'productBroadCategory',
          align: 'center',
          width: 120,
          ellipsis: true,
          fixed: 'left'
        },
        {
          title: '类型',
          dataIndex: 'type',
          align: 'center',
          width: 150,
          ellipsis: true,
          fixed: 'left'
        }
      ],
      // 表格字段
      preColumns: [
        {
          title: '供应商名称',
          dataIndex: 'supplierName',
          align: 'center',
          width: 250,
          ellipsis: true,
          fixed: 'left'
        },
        {
          title: '工艺大类',
          dataIndex: 'productBroadCategory',
          align: 'center',
          width: 120,
          ellipsis: true,
          fixed: 'left'
        },
        {
          title: '类型',
          dataIndex: 'type',
          align: 'center',
          width: 150,
          ellipsis: true,
          fixed: 'left'
        }
      ],
      nextColumns: [
        {
          title: '创建人',
          dataIndex: 'createName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '最后更新人',
          dataIndex: 'updateName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '最后更新时间',
          dataIndex: 'updateTime',
          align: 'center',
          width: 150,
          ellipsis: true
        }
      ],
      tableData: [],
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/scp/scpSopBasicCapacityLoad/import'
      }
    }
  },
  created () {},
  mounted () {
    this.onSearch()
  },
  methods: {
    // 表单搜索
    onSearch (value = {}) {
      const params = {
       ...this.queryParams,
       ...value
      }
      delete params.searchFormLabel
      this.$refs.dataTable.searchParams = params;
      apiScpSopBasicCapacityLoadList(params).then(res => {
        console.log(res)
        const { rows, title } = res.data
        const tempMonthColumns = []
        title.forEach(item => {
          tempMonthColumns.push({
            title: item.indexName,
            dataIndex: item.indexKey,
            align: 'center',
            width: 120,
            ellipsis: true
          })
        })
        this.columns = [ ...this.preColumns, ...tempMonthColumns, ...this.nextColumns ]
        this.$refs.dataTable.myDataSource = rows
      })
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        supplierId: undefined,
        productBroadCategory: undefined
      }
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 导出
    handleExport () {
      this.download('scp/scpSopBasicCapacityLoad/export', this.$refs.dataTable.searchParams, `产能工时维护_${moment().format('YYYY-MM-DD')}.xlsx`)
    },
    // 下载模板
    handleDownloadTemplate () {
      this.download('scp/scpSopBasicCapacityLoad/template', {
        ...this.$refs.dataTable.searchParams
      }, `产能工时维护导入模板_${new Date().getTime()}.xlsx`)
    },
    handleImport () {
      this.excelVisible = true
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.onSearch();
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        if (info.file.response.code === 200) {
          this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
        } else {
          this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
        }
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    }
  }
}
</script>

<style scoped lang="less"></style>
